import { render } from "./PopupModal.vue?vue&type=template&id=6fea3f83"
import script from "./PopupModal.vue?vue&type=script&lang=js"
export * from "./PopupModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__